<template>
  <div
    class="mobile-enquiry-button pt-3 px-3 flex shadow-bar-bottom"
    :class="className"
  >
    <template v-if="$store.getters.isRtbFlowPossible">
      <div v-if="!isGalleryOpen" class="w-1/2">
        <EnquiryPricingMobileBar />
      </div>

      <BaseButton
        style="min-width: 180px;"
        color="red"
        class="grow"
        size="large"
        @click="submit"
      >
        Request to book
      </BaseButton>
    </template>

    <template v-else>
      <AddToFavouritesSmall v-if="!isGalleryOpen" class="mr-1" />

      <BaseButton
        :reduced-paddings="true"
        color="red"
        class="grow"
        size="large"
        @click="submit"
      >
        {{ $store.getters.isWedding ? 'Request a free brochure' : 'Enquire now' }}
      </BaseButton>
    </template>
  </div>
</template>

<script>
import ScreenWidth from '@/components/ScreenWidth';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

import EnquiryPricingMobileBar from '../EnquiryPricingMobileBar.vue';
import AddToFavouritesSmall from './AddToFavouritesSmall.vue';

export default {
  name: 'MobileBottomButton',
  emits: ['click'],
  mixins: [ScreenWidth],
  components: {
    EnquiryPricingMobileBar,
    AddToFavouritesSmall,
    BaseButton,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isGalleryOpen: window.location.hash === '#mosaic-gallery',
    };
  },

  computed: {
    className() {
      if (this.isGalleryOpen && !this.isBigDesktop) {
        return 'mobile-enquiry-button--galleryVisible';
      }
      if (this.isVisible) {
        return '';
      }
      return 'mobile-enquiry-button--invisible';
    },
    trackingElement() {
      if (!this.$store.getters.isRtbFlowPossible) {
        return this.$store.getters.isWedding ? 'request_brochure_button' : 'enquire_now_button';
      }

      return 'request_to_book_button';
    },
  },

  methods: {
    track() {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'mobile_widget',
        element: this.trackingElement,
        value: null,
        interaction: 'click',
      });
    },
    submit() {
      this.$emit('click');

      if (this.isGalleryOpen) {
        $.publish('room_page_interaction', {
          section: 'photos_mosaic',
          element: this.trackingElement,
          interaction: 'click',
        });
      } else {
        this.track(this.trackingElement);
      }
    },
  },

  mounted() {
    window.onGalleryOpen = () => {
      this.isGalleryOpen = true;

      $.publish('room_page_interaction', {
        section: 'photos_mosaic',
        element: this.trackingElement,
        interaction: 'visible',
      });
    };
    window.onGalleryClose = () => {
      this.isGalleryOpen = false;
    };
  },
};
</script>

<style lang="scss" scoped>
.mobile-enquiry-button {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  background: white;
  left: 0;
  right: 0;
  transition: transform 0.2s ease-out;
  transform: translateY(0);

  padding-bottom: 12px;
  @supports (padding: env(safe-area-inset-bottom)) {
    padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;
  }
}

.mobile-enquiry-button--galleryVisible {
  z-index: 10002;
}

.mobile-enquiry-button--invisible {
  transform: translateY(100%);
}
</style>
